import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import axios from "axios";

const API_BASE_URL_AUTH = process.env.REACT_APP_API_BASE_URL_AUTH;

export const loginUser = createAsyncThunk(
  "api/fetchData",
  async (userData, { rejectWithValue }) => {
    const formBody = new URLSearchParams();
    formBody.append("username", userData.username);
    formBody.append("password", userData.password);
    formBody.append("grant_type", "password");
    // const response = await axios.get(
    //   "https://jsonplaceholder.typicode.com/posts"
    // );

    try {
      const response = await axios.post(
        `${API_BASE_URL_AUTH}/oauth/token`,
        formBody,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Basic cGh5YmVyLWNsaWVudDpwaHliZXItc2VjcmV0",
            Accept: "application/json, text/plain, */*",
          },
        }
      );
      let status = "success";
      let data = {
        status: status,
        message: response.data,
      };
      return data; // Success: return data
    } catch (error) {
      // Handle error: rejectWithValue ensures proper error handling
      let status = "error";
      let data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data;
    }
  }
);

const loginSlice = createSlice({
  name: "api",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default loginSlice.reducer;
